import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { type FC } from "react"

import { type ThinBundle } from "@forento/core/models/bundle"

import { DeleteIcon, EditIcon } from "~/components/Icon"
import ProductListRow from "~/components/ProductListRow"
import { useAlert } from "~/contexts/AlertContext"
import routes from "~/utilities/routes"
import trpc from "~/utilities/trpc"

type Props = { bundle: ThinBundle; onDelete(): Promise<unknown> }
const Bundle: FC<Props> = ({ bundle, onDelete }) => {
	const alert = useAlert()

	const { setNodeRef, transform, transition, attributes, listeners } = useSortable({ id: bundle.id })

	async function handleDelete() {
		const dialog = await alert.confirm(
			"Delete bundle",
			`Are you sure you want to delete the bundle *${bundle.name}*? All existing purchases will be unaffected.`,
		)
		if (!dialog.result) return

		try {
			await trpc.bundle.delete.mutate(bundle.id)
			await onDelete()
			dialog.close()
		} catch (error) {
			console.error(error)
			await alert.show("Error", "Failed to delete bundle. Please try again later.")
		}
	}

	return (
		<ProductListRow
			ref={setNodeRef}
			title={bundle.name}
			subtitle={bundle.items.map(x => x.name).join(", ")}
			actions={[
				{ id: "edit", tooltip: "Edit", icon: EditIcon, href: routes.bundle.detail(bundle.id) },
				{ id: "delete", tooltip: "Delete", icon: DeleteIcon, danger: true, onClick: handleDelete },
			]}
			dragHandle={{ attributes, listeners }}
			style={{ transform: CSS.Transform.toString(transform), transition }}
		/>
	)
}

export default Bundle
